import { useState } from 'react';
import { formatCurrency } from '@atc/string-fns';
import { useDevice } from '@atc/react-device';
import { sendClick } from 'reaxl-analytics';
import { inventoryClick } from 'reaxl-analytics-handlers';
import { useFeatures } from '@atc/features';
import { Image, Text, Button, Glyphicon, Link } from 'reaxl';
import { InventoryImagePlaceholder, OwnerTextCTA, OwnerPhoneNumber } from 'reaxl-molecules';
import DealCardAlert from './DealCardAlert.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
const pipe = /*#__PURE__*/jsx("span", {
  className: "padding-horizontal-2",
  children: "|"
});
function DealCardVehicleOverview(_ref) {
  let {
    dealData = {},
    indexClicked,
    onEmailDealerClick,
    onPhoneClick,
    onTextClick
  } = _ref;
  const device = useDevice();
  const isXs = device?.is?.xs || false;
  const [imageIsBroken, setImageIsBroken] = useState(false);
  const {
    active_deals_my_wallet: [, {
      contact_email: enableEmail,
      contact_phone: enablePhone,
      contact_sms: enableSMS
    }]
  } = useFeatures(['active_deals_my_wallet']);
  const {
    vehicle = {},
    dealer,
    deal = {}
  } = dealData;
  const {
    phone = {},
    textNumber = '',
    name: dealerName
  } = dealer;
  const {
    imageUrl,
    sellingPrice,
    title,
    vdpUrl
  } = vehicle;
  const {
    dealType = '',
    payment
  } = deal;
  const showPhone = enablePhone && isXs && !!Object.keys(phone).length;
  const showSMS = enableSMS && isXs && !!textNumber;
  const onVehicleClick = event => sendClick(inventoryClick, event, {
    par: 'dealdetails',
    vehicle,
    indexClicked
  });
  const handleImageError = () => setImageIsBroken(true);
  const analyticsData = {
    inventoryId: vehicle?.id,
    ownerId: dealer?.id,
    placement: 'myWallet' // Tentative to change in tagging story.
  };
  const vehicleTitle = vdpUrl ? /*#__PURE__*/jsx(Link, {
    href: vdpUrl,
    className: "text-bold margin-bottom-1",
    undecorated: true,
    children: title
  }) : /*#__PURE__*/jsx(Text, {
    weight: "bold",
    className: "margin-bottom-1",
    children: title
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(DealCardAlert, {
      ...dealData
    }), /*#__PURE__*/jsxs("div", {
      className: "margin-bottom-2 display-flex",
      onClick: onVehicleClick,
      role: "button",
      tabIndex: "0",
      children: [/*#__PURE__*/jsx("div", {
        style: {
          maxWidth: '33%'
        },
        children: imageUrl && !imageIsBroken ? /*#__PURE__*/jsx(Image, {
          src: imageUrl.replace('https:https:', 'https:'),
          style: {
            width: '100%'
          },
          onError: handleImageError
        }) : /*#__PURE__*/jsx(InventoryImagePlaceholder, {
          className: "rounded padding-2",
          height: 75
        })
      }), /*#__PURE__*/jsxs("div", {
        className: "margin-left-3",
        children: [vehicleTitle, /*#__PURE__*/jsxs("div", {
          className: "display-flex flex-wrap",
          children: [/*#__PURE__*/jsx(Text, {
            weight: "bold",
            className: "display-block",
            children: formatCurrency(sellingPrice)
          }), pipe, /*#__PURE__*/jsx(Text, {
            transformCase: "capitalize",
            children: dealType
          }), dealType?.toLowerCase() !== 'cash' && /*#__PURE__*/jsxs(Fragment, {
            children: [pipe, /*#__PURE__*/jsx(Text, {
              children: `Est. ${formatCurrency(Math.round(payment))}/mo.`
            })]
          })]
        }), dealer && /*#__PURE__*/jsxs(Fragment, {
          children: [dealerName && /*#__PURE__*/jsx(Text, {
            children: dealerName
          }), (enableEmail || showSMS || showPhone) && /*#__PURE__*/jsxs("div", {
            className: "display-flex",
            children: [enableEmail && /*#__PURE__*/jsxs(Button, {
              bsStyle: "text",
              className: "link-unstyled text-bold margin-right-5",
              onClick: event => onEmailDealerClick(event, 'wallet'),
              children: [/*#__PURE__*/jsx(Glyphicon, {
                glyph: "envelope",
                className: "margin-right-2 text-accent"
              }), "Email"]
            }), showSMS && /*#__PURE__*/jsx(OwnerTextCTA, {
              analyticsData: analyticsData,
              buttonBsStyle: "link",
              iconClassName: "text-accent",
              className: "link-unstyled text-bold margin-right-5 padding-0",
              label: "Text",
              phoneNumber: textNumber,
              textBody: `I'd like to follow up on my deal for the ${title}`,
              uiContext: "button",
              textClickHandler: onTextClick
            }, "text-cta-owner-text"), showPhone && /*#__PURE__*/jsx(OwnerPhoneNumber, {
              analyticsData: analyticsData,
              buttonStyle: "link",
              iconClassName: "text-accent",
              className: "link-unstyled text-bold padding-0",
              phone: phone,
              uiContext: "button",
              buttonLabel: "Call",
              phoneClickHandler: onPhoneClick
            }, "call-cta-owner-phone-number")]
          })]
        })]
      })]
    })]
  });
}
export { DealCardVehicleOverview as default };
